module.exports = __webpack_public_path__ + "static/media/eduardo@3x.c05c52d8.jpg";